import { render, staticRenderFns } from "./CardFormats.vue?vue&type=template&id=7e057489&scoped=true"
import script from "./CardFormats.js?vue&type=script&lang=js&external"
export * from "./CardFormats.js?vue&type=script&lang=js&external"
import style0 from "./CardFormats.scss?vue&type=style&index=0&id=7e057489&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e057489",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
